import { render, staticRenderFns } from "./FlankLogo.vue?vue&type=template&id=46b5f2ba&"
import script from "./FlankLogo.vue?vue&type=script&lang=ts&"
export * from "./FlankLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports